export function  calcDiscount(disc,bsum){
  if(disc){
    if(disc.val_type=="percentage"){
      return parseFloat(bsum)*(disc.val/100)
    }else{
      return disc.val;
    }
  }else{
    return 0
  }
}


export function  getBillSum(clsid,bsums){
  let cbill = bsums.filter(x=>x.cid==clsid);
  //console.log(cbill)
   return cbill[0]?cbill[0].cbsum:0

}


export const validRules = {
  required:[v => !!v || "this field is required"],
  password: [
    v => !!v || "Password is required",
    v =>(v && v.length >= 8) || "Password must not be less than 8 characters"
],
  email: [
    // v => !!v || "E-mail is required",
    v =>(!v ||
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v)) ||
      "E-mail must be valid"
  ],
  email2: [

    v =>(!v ||
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v)) ||
      "E-mail must be valid"
  ],
  c_score:[
    v => !!v || "class score is required",
    v =>(v && v <= 30) || "class score cannot be more than 30%"
  ],
  e_score:[
    v => !!v || "exam score is required",
    v =>(v && v <= 70) || "Exam score cannot be more than 70%"
  ]
}







// WEBPACK FOOTER //
// ./resources/assets/js/common/index.js